import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {SessionService} from '../../shared/service/session.service';
import {ActivatedRoute} from '@angular/router';
import {PaymentModel} from '../../model/payment.model';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {FormControl, FormGroup} from '@angular/forms';
import {MatTableDataSource} from '@angular/material/table';
import {ApprovalService} from '../../service/approval.service';
import {ApprovalPending} from '../../shared/dto/approval-pending';
import {TokenStorageService} from '../../shared/service/token-storage.service';

@Component({
  selector: 'app-approval-pending-list',
  templateUrl: './approval-pending-list.component.html',
  styleUrls: ['./approval-pending-list.component.scss']
})
export class ApprovalPendingListComponent implements OnInit {
  public userName: string;
  public type: string;
  approvalSearchForm: FormGroup;
  public approvalPendingList: ApprovalPending[];
  approvalPending: ApprovalPending = new ApprovalPending();
  displayedColumns: string[] = ['refNo', 'nic', 'name', 'cdc' ,'stage', 'createdDate', 'action'];
  dataSource: MatTableDataSource<any>;
  isLoading: boolean = false;

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(private route: ActivatedRoute, private approvalService: ApprovalService,
              private tokenStorageService: TokenStorageService) {
    this.route.paramMap.subscribe(params => {
      this.type = params.get('type');
    });
    this.userName=this.tokenStorageService.getUserObjectToken().username;
  }

  ngOnInit() {
    this.approvalSearchForm = new FormGroup({
      appRefNo: new FormControl(null),
      name: new FormControl(null),
      nic: new FormControl(null),
      cdcNo: new FormControl(null),
    });
    this.onSearch();
  }

  setBase64(code: string): string {
    return btoa(code);
  }

  onSearch() {
    this.isLoading = true;
    this.approvalPending.appRefNo = this.approvalSearchForm.value.appRefNo;
    this.approvalPending.cdcNo = this.approvalSearchForm.value.cdcNo;
    this.approvalPending.name = this.approvalSearchForm.value.name;
    this.approvalPending.nic = this.approvalSearchForm.value.nic;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = this.type;

    this.approvalService.searchApprovalPendingData(this.approvalPending).subscribe(
      (result: any ) => {
        this.approvalPendingList = result;
        this.isLoading = false;
        this.dataSource = new MatTableDataSource(this.approvalPendingList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onReset() {
    this.approvalSearchForm.reset({
      appRefNo: null,
      name: null,
      nic: null,
      cdcNo: null,
    });
    this.getAllRequestDetails();
  }

  getAllRequestDetails(){
    this.isLoading = true;
    this.approvalPending.appRefNo = this.approvalSearchForm.value.appRefNo;
    this.approvalPending.cdcNo = this.approvalSearchForm.value.cdcNo;
    this.approvalPending.name = this.approvalSearchForm.value.name;
    this.approvalPending.nic = this.approvalSearchForm.value.nic;
    this.approvalPending.loginUser = this.userName;
    this.approvalPending.type = this.type;

    this.approvalService.searchApprovalPendingData(this.approvalPending).subscribe(
      (result: any ) => {
        this.approvalPendingList = result;
        this.isLoading = false;
        this.dataSource = new MatTableDataSource(this.approvalPendingList);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }
}
